export const SET_APP_CONTEXT = 'SET_APP_CONTEXT';
